var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
        name: 'Home',
        icon: 'img-icon img-icon-home-nav',
        path: '/home'
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: 'Live Jobs',
        icon: 'img-icon img-icon-live-nav',
        path: '/live'
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: 'Job History',
        icon: 'img-icon img-icon-jobs-nav',
        path: '/jobs'
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: 'Files',
        icon: 'img-icon img-icon-media-nav',
        path: '/media'
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: 'Manifests',
        icon: 'img-icon img-icon-cart-full',
        path: '/manifests'
      }}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }